import React from "react";
import SendBird from "sendbird";
import {generateUUID} from "./utility";

const IS_DISTINCT = true;

let sbUserObj = {}
let currentUserID = "";
let instance, channelListQueryInstance;

const createInstance = () => {
    return new SendBird({appId: process.env.REACT_APP_SENDBIRD_APP_ID});
}

const getInstance = () => {
    if (!instance) {
        instance = createInstance();
    }
    return instance;
}

const createChannelListQueryInstance = () => {
    const sb = getInstance();
    channelListQueryInstance = sb.GroupChannel.createMyGroupChannelListQuery();
    channelListQueryInstance.includeEmpty = true;
    channelListQueryInstance.order = 'latest_last_message'; // 'chronological', 'latest_last_message', 'channel_name_alphabetical', and 'metadata_value_alphabetical'
    channelListQueryInstance.limit = 15;    // The value of pagination limit could be set up to 100.
    return channelListQueryInstance;
}

const getChannelListQueryInstance = () => {
    // if (!channelListQueryInstance) {
    //     channelListQueryInstance = createChannelListQueryInstance();
    // }

    return createChannelListQueryInstance();
}

const getSBUserObj = () => {
    return sbUserObj;
}

const getCurrentUserID = () => {
    console.log("getCurrentUserID",currentUserID)
    return currentUserID;
}

const sbConnect = (USER_ID, SESSION_TOKEN, successCallback, errorCallback) => {
    if (!sbUserObj.hasOwnProperty(USER_ID)) {
        sbUserObj[USER_ID] = null;
        const sb = getInstance();
        sb.connect(USER_ID, SESSION_TOKEN, function (user, error) {
            if (error) {
                errorCallback(error);
            } else {
                successCallback(user);
                sbUserObj[USER_ID] = user;
                currentUserID = USER_ID;
            }
        });
    }else{
        successCallback(sbUserObj[USER_ID]);
    }
}

/**
 * @description Receive messages through a channel event handler
 * @param callback
 * @url https://sendbird.com/docs/chat/v3/javascript/guides/group-channel#2-receive-messages-through-a-channel-event-handler
 */
const sbAddChannelHandler = (callback) => {
    const sb = getInstance();
    const UNIQUE_HANDLER_ID = generateUUID();
    let channelHandler = new sb.ChannelHandler();
    console.log("sbAddChannelHandler >> UNIQUE_HANDLER_ID = "+UNIQUE_HANDLER_ID+" >> channelHandler", channelHandler)
    channelHandler.onMessageReceived = function (channel, message) {
        console.log("addChannelHandler", {channel, message})
        callback(channel, message);
    };

    sb.addChannelHandler(UNIQUE_HANDLER_ID, channelHandler);
}

/**
 * @description Receive messages through a channel event handler
 * @url https://sendbird.com/docs/chat/v3/javascript/guides/group-channel#2-receive-messages-through-a-channel-event-handler
 */
const sbRemoveChannelHandler = () => {
    const sb = getInstance();
    const UNIQUE_HANDLER_ID = getCurrentUserID();
    sb.removeChannelHandler(UNIQUE_HANDLER_ID);
}
/**
 * @description Create a channel
 * @param userIds
 * @param successCallback
 * @param errorCallback
 * @url https://sendbird.com/docs/chat/v3/javascript/guides/group-channel#2-create-a-channel
 */
const sbCreateChannel = (userIds, successCallback, errorCallback) => {
    const sb = getInstance();
    console.log("sbCreateChannel >> userIds", userIds)
    sb.GroupChannel.createChannelWithUserIds(userIds, IS_DISTINCT, "", "", "", "", function (groupChannel, error) {
        if (error) {
            errorCallback(error);
        } else {
            successCallback(groupChannel);
        }
    });
}

/**
 * @description Retrieve a list of channels
 * @param user_type
 * @param successCallback
 * @param errorCallback
 * After creating a query instance from the createMyGroupChannelListQuery() and using the instance's next() method
 * which returns a list of group channel objects, you can get a list of the current user's joined channels.
 * @url https://sendbird.com/docs/chat/v3/javascript/guides/group-channel#2-retrieve-a-list-of-channels
 */

const sbRetrieveListOfChannels = (user_type, successCallback, errorCallback) => {
    const channelListQuery = getChannelListQueryInstance();
    console.log("sbRetrieveListOfChannels >> user_type", user_type);
    console.log("sbRetrieveListOfChannels >> channelListQuery", channelListQuery);
    console.log("sbRetrieveListOfChannels >> channelListQuery.hasNext", channelListQuery.hasNext);

    if (channelListQuery.hasNext) {
        channelListQuery.next(function (groupChannels, error) {

            console.log("sbRetrieveListOfChannels >> groupChannels", groupChannels);
            console.log("sbRetrieveListOfChannels >> error", error);

            if (error) {
                errorCallback(error)
            }

            successCallback(groupChannels);
        });
    }
}


const sbSearchInListOfChannels = (query, successCallback, errorCallback) => {
    const sb = getInstance();
    let myChannelListQuery = sb.GroupChannel.createMyGroupChannelListQuery();
    myChannelListQuery.includeEmpty = true;
    myChannelListQuery.nicknameContainsFilter = query;

    console.log("sbSearchInListOfChannels >> query", query);

    myChannelListQuery.next(function (groupChannels, error) {

        console.log("sbSearchInListOfChannels >> error", error);
        console.log("sbSearchInListOfChannels >> groupChannels", groupChannels);

        if (error) {
            errorCallback(error);
        }

        // A list of group channels that have 'Sendbird' in their names is returned.
        successCallback(groupChannels);
    });
}

/**
 * @description Retrieve a channel by URL
 * Since a channel URL is a unique identifier of a group channel, you can use a URL when retrieving a channel object.
 * @url https://sendbird.com/docs/chat/v3/javascript/guides/group-channel#2-retrieve-a-channel-by-url
 * @param CHANNEL_URL
 * @param successCallback
 * @param errorCallback
 */
const sbRetrieveChannelByURL = (CHANNEL_URL, successCallback, errorCallback) => {
    const sb = getInstance();
    sb.GroupChannel.getChannel(CHANNEL_URL, function (groupChannel, error) {
        console.log("sbRetrieveChannelByURL >> CHANNEL_URL", CHANNEL_URL);
        console.log("sbRetrieveChannelByURL >> groupChannel", groupChannel);
        console.log("sbRetrieveChannelByURL >> error", error);
        if (error) {
            errorCallback(error);
        }
        successCallback(groupChannel)
    });
}

/**
 *
 * @param groupChannel
 * @param successCallback
 * @param errorCallback
 */
const sbLoadPreviousMessage = (groupChannel, successCallback, errorCallback) => {
    // There should only be one single instance per channel view.
    let prevMessageListQuery = groupChannel.createPreviousMessageListQuery();
    prevMessageListQuery.limit = 15;
    prevMessageListQuery.reverse = true;
    prevMessageListQuery.includeMetaArray = true;   // Retrieve a list of messages along with their metaarrays.
    prevMessageListQuery.includeReaction = true;    // Retrieve a list of messages along with their reactions.

    // Retrieving previous messages.
    prevMessageListQuery.load(function (messages, error) {

        console.log("sbLoadPreviousMessage >> groupChannel", groupChannel);
        console.log("sbLoadPreviousMessage >> messages", messages);
        console.log("sbLoadPreviousMessage >> error", error);

        if (error) {
            errorCallback(error)
        }

        successCallback(messages)
    });
}


const sbSendMessage = (channel, message, data, mentionedUserIds, successCallback, errorCallback) => {
    const sb = getInstance();
    const params = new sb.UserMessageParams();

    params.message = message;
    //params.customType = CUSTOM_TYPE;
    if (data) {
        params.data = data;
    }
    params.mentionType = 'users';                       // Either 'users' or 'channel'
    if (mentionedUserIds) {
        params.mentionedUserIds = mentionedUserIds;        // Or mentionedUsers = Array<User>;
    }
    //params.metaArrayKeys = ['linkTo', 'itemType'];
    //params.translationTargetLanguages = ['fe', 'de'];   // French and German
    params.pushNotificationDeliveryOption = 'default';  // Either 'default' or 'suppress'

    channel.sendUserMessage(params, function (message, error) {

        console.log("sbSendMessage", {
            channel, message, data, mentionedUserIds
        });

        console.log("sbSendMessage >> message", message);
        console.log("sbSendMessage >> error", error);

        if (error) {
            errorCallback(error);
        }

        successCallback(message);
    });
}

const sbArchive = (channel, successCallback, errorCallback) => {
    channel.hide(false, true, function (response, error) {
        if (error) {
            errorCallback(error);
        }

        successCallback(response);
    });
}

const sbUnArchive = (channel, successCallback, errorCallback) => {

    channel.unhide(function (response, error) {
        if (error) {
            errorCallback(error);
        }

        successCallback(response);
    });
}

const sbDeleteByID = (channel, message, successCallback, errorCallback) => {
    // The MESSAGE below indicates a UserMessage or FileMessage object to delete.
    channel.deleteMessage(message, function (response, error) {
        if (error) {
            errorCallback(error);
        }

        successCallback(response);
    });
}

export default {
    getInstance,
    sbConnect,
    sbAddChannelHandler,
    sbRemoveChannelHandler,
    sbCreateChannel,
    sbRetrieveListOfChannels,
    sbSearchInListOfChannels,
    sbRetrieveChannelByURL,
    sbLoadPreviousMessage,
    sbSendMessage,
    sbArchive,
    sbUnArchive,
    sbDeleteByID,

    getCurrentUserID,
    getSBUserObj
}